import { Flex, Link, Card, CardHeader, CardBody, CardFooter, Image, Text, Divider, Stack, HStack, Button } from "@chakra-ui/react"
import { useEffect } from "react";
import kcookingtrip from '../assets/images/kcookingtrip.png';

const Redirect = () => {
  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();

    if (/android/.test(ua)) {
      window.location.href = "https://play.google.com/store/apps/details?id=com.dododot.kcookingtrip";
    } else if (/iphone|ipad|ipod/.test(ua)) {
      window.location.href = "https://apps.apple.com/app/id6739463720";
    } else {
      window.location.href = "https://dodo-dot.com";
    }
  }, []);

  return(
    <Flex alignItems="top" justifyContent="center" flex="1" bgColor="#FFFFFF" mt={4}>
        <Stack>

        <Image
        src={kcookingtrip}
        alt="k-cookingtrip"
        />
        <Text fontSize="xl" fontWeight="bold">KCookingTrip</Text>
        <div>Redirecting to the app...</div>
        </Stack>
    </Flex>
  )
};

export default Redirect;
